import { render, staticRenderFns } from "./DailyUsages.vue?vue&type=template&id=54e1b906"
import script from "./DailyUsages.vue?vue&type=script&lang=js"
export * from "./DailyUsages.vue?vue&type=script&lang=js"
import style0 from "./DailyUsages.vue?vue&type=style&index=0&id=54e1b906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports